import PropTypes from 'prop-types'
import { Circle } from '../../Styling/styledForm/styledBlueForm'

export function RatingCircle({
  value,
  thresholds,
  fallback = 'Ikke ratet',
}) {

  if (value === '' || value == null) {
    return <span
        style={{
          display: 'inline-block', 
          padding: '10px',
        }}
      >
        {fallback}
      </span>
  }

  const n = Number(value)
  if (isNaN(n)) {
    return <span style={{      
        display: 'inline-block', 
        padding: '10px'
      }}
    >
      {fallback}
    </span>
  }

  const match = thresholds.find(t => n <= t.max)
  const color = match?.color || thresholds[thresholds.length - 1].color

  return (
    <span style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
      <Circle primary={color}></Circle>
    </span>
  )
}

RatingCircle.propTypes = {
  value:      PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fallback:   PropTypes.string,
  thresholds: PropTypes.arrayOf(
    PropTypes.shape({
      max:   PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
    })
  ).isRequired,
}

RatingCircle.defaultProps = {

  // Rød: 0 - 560
  // Gul: 561 - 620
  // Grønn: 621 - infinity
  
  thresholds: [
    { max: 560, color: 'red'    },
    { max: 620, color: 'yellow' },
    { max: Infinity, color: 'green' },
  ],
}


/* Gammel løsning

const printRating = () => {

      function isNumeric(num) {
        return !isNaN(num)
      }

      let ratingstring = model.debtorRating ? model.debtorRating.trim() : ''
      let outputString = ''
      let rcolor = 'white'
      let showBall = false


      if (!ratingstring) {
        outputString = 'Ikke ratet'
      } else {
        if (isNumeric(ratingstring)) {
          let rating = parseInt(ratingstring)
          showBall = true

          if (rating <= 30) {
            rcolor = 'red'
          } else if (rating <= 65) {
            rcolor = 'yellow'
          } else {
            rcolor = 'green'
          }
        }
      }

      // rating < 30 - sak - skal lete etter en slik sak
      // 30<rating<60 sak 3S4SZ5
      // rating > 60 sak 3S5B4W
    
      // Rød "prikk" hvis ratingstallet er <30
      // Gul "prikk" hvis ratingstallet er mellom 30 og 60
      // Grønn "prikk" hvis ratingstallet >60
    
      return (

        <div style={{paddingTop: '6px', paddingBottom: '6px'}}>
          {showBall &&
            <Circle $primary={rcolor}></Circle>
          }
          {outputString}
        </div>
      )
    }
  */
